import { Location } from '@angular/common';
import { Component, forwardRef, Inject, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'temporary-landing-page',
    template: ''
})
export class TemporaryLandingPageComponent implements OnDestroy {

    private subscription: Subscription;

    constructor(
        @Inject(forwardRef(() => Router)) private router: Router,
        @Inject(forwardRef(() => Location)) private browserLocation: Location
    ) {
        this.subscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const url = this.browserLocation.path();
                this.router.navigate([url], { skipLocationChange: true });
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }
}